"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDrawingParameterSettings = exports.IDrawingParameterJsonSchema = void 0;
const zod_1 = require("zod");
// #endregion Interfaces (2)
// #region Variables (2)
exports.IDrawingParameterJsonSchema = zod_1.z.object({
    geometry: zod_1.z
        .object({
        mode: zod_1.z.enum(["points", "lines"]),
        minPoints: zod_1.z.number().optional(),
        maxPoints: zod_1.z.number().optional(),
        strictMinMaxPoints: zod_1.z.boolean().optional(),
        close: zod_1.z.boolean(),
    })
        .optional(),
    restrictions: zod_1.z.array(zod_1.z.any()).optional(),
    general: zod_1.z
        .object({
        prompt: zod_1.z
            .object({
            inactiveTitle: zod_1.z.string().optional(),
            activeTitle: zod_1.z.string().optional(),
            activeText: zod_1.z.string().optional(),
        })
            .optional(),
    })
        .optional(),
});
const validateDrawingParameterSettings = (param) => {
    return exports.IDrawingParameterJsonSchema.safeParse(param);
};
exports.validateDrawingParameterSettings = validateDrawingParameterSettings;
// #endregion Variables (2)
//# sourceMappingURL=IDrawingParametersSettings.js.map